import type { IconNode } from '../types';

/**
 * @name server-nas
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTZWOCIgLz4KICA8cGF0aCBkPSJNMTQgMTZWOCIgLz4KICA8cGF0aCBkPSJNMTggMTZWOCIgLz4KICA8cGF0aCBkPSJNNiAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTYgMTZoLjAxIiAvPgogIDxyZWN0IHg9IjIiIHk9IjQiIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgcng9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/server-nas
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ServerNas: IconNode = [
  ['path', { d: 'M10 16V8' }],
  ['path', { d: 'M14 16V8' }],
  ['path', { d: 'M18 16V8' }],
  ['path', { d: 'M6 12h.01' }],
  ['path', { d: 'M6 16h.01' }],
  ['rect', { x: '2', y: '4', width: '20', height: '16', rx: '2' }],
];

export default ServerNas;
